import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';

import RequestCalloutTypes from '../types/RequestCalloutTypes';
import TypeColumnIcon from './TypeColumnIcon';
import CalloutButtonForManager from './CalloutButtonForManager';
import RequestedAgoLabel from './RequestedAgoLabel';
import CalloutStatusLabelForManager from './CalloutStatusLabelForManager';


interface CalloutTableForManagerProps {
    calloutList: IRequestCalloutDTO[],
    openAssignVehicleModal: any
};

const useStyles = makeStyles(() => ({
    container: {},
    table: {
        width: "100%",

        tableLayout: "fixed",
        backgroundColor: "#00152E"
    },
    muiTableBody: {
        backgroundColor: "#fff",
    },
    tableHead: {
        backgroundColor: "#00152E",
        paddingLeft: 30,
        "& > *": {
            fontSize: 18,
            fontWeight: 400,
            opacity: 0.30,
        }
    },
    tableBody: {
        backgroundColor: "#002047",
        cursor: "pointer",
        "& > *": {
            fontSize: 18,
            fontWeight: 500
        },
        height: 33
    },
    tableCell: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        height: 33,
    },
    myVehicleCell: {
        backgroundColor: 'rgba(63, 160, 82, 0.23)'
    },

}));

const CalloutTableForManager: React.FC<CalloutTableForManagerProps> = ({ 
    calloutList, 
    openAssignVehicleModal}) => {
    const classes = useStyles();
    const EmptyRow = (<TableRow className={classes.tableCell}>
        <TableCell align="center" colSpan={9}>No Records Found</TableCell>
    </TableRow>);
    return (
        <div className={classes.container}>
            <Table size="small" aria-label="purchases" style={{ tableLayout: "fixed" }}>
                <TableHead>
                    <TableRow className={classes.tableHead}>
                        <TableCell width="6%">Type</TableCell>
                        <TableCell width="14%">Requested</TableCell>
                        <TableCell width="24%">Location</TableCell>
                        <TableCell width="20%">Section</TableCell>
                        <TableCell width="22%"></TableCell>
                        <TableCell width="14%"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {calloutList.length === 0 ? EmptyRow :
                        calloutList.map((row, index) => {
                            const isItIncident = row.type === RequestCalloutTypes.incidentCallout;
                            const cellClass = classes.tableCell;
                            return (
                                <React.Fragment key={row.requestCalloutId}>
                                    <TableRow
                                        onClick={() => { }}
                                        hover
                                        className={classes.tableBody}
                                    >
                                        <TableCell className={cellClass}>
                                            <TypeColumnIcon isItIncident={isItIncident} />
                                        </TableCell>

                                        <TableCell className={cellClass} >
                                                <RequestedAgoLabel 
                                                    row={row}
                                                    isMyVehicle={true} 
                                                />
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                            {row.locationName ?? '-'}
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                            {row.wardName ?? '-'}
                                        </TableCell>
                                        <TableCell className={cellClass} >
                                            <CalloutStatusLabelForManager row={row} />
                                        </TableCell>
                                        <TableCell className={cellClass} style={{padding:0}}>
                                            <CalloutButtonForManager 
                                                row={row}
                                                openAssignVehicleModal={openAssignVehicleModal}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )
                        })}
                </TableBody>
            </Table>
        </div>
    );
}

export default CalloutTableForManager;